/* "On this page" -- builds a TOC from h2/h3 in the article body, with scrollspy.
   Also wraps any bare <table> in a scrollable container (see wrapTables below)
   and removes the legacy Table of Contents app's own output (see removeRuffruffToc). */
(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  /* The legacy "Table of Contents" app sets its own inline
     style="display:flex !important" on its rendered container -- confirmed
     live. An inline !important always wins over an external stylesheet's
     !important, no matter how specific the selector, so a CSS-only hide can
     never work here. Removing the element from the DOM entirely sidesteps
     that fight. It hydrates asynchronously (absent from the raw server HTML,
     built by the app's own JS after load), so a MutationObserver catches it
     whenever it actually appears rather than racing a fixed timeout. */
  function removeRuffruffToc(articleBody) {
    function tryRemove() {
      var el = articleBody.querySelector('#ruffruff-table-of-contents, .ruffruff-table-of-contents');
      if (el) {
        el.remove();
        return true;
      }
      return false;
    }
    if (tryRemove()) return;
    var observer = new MutationObserver(function () {
      if (tryRemove()) observer.disconnect();
    });
    observer.observe(articleBody, { childList: true, subtree: true });
  }

  /* A <table> with display:block loses its native table-layout formatting
     context (cells stop reliably filling the intended width), and overflow-x
     on the table itself can't create a scrollbar for content that's wider
     than the table's own box -- only a wrapping element can. So this wraps
     every bare table in a plain div and puts the border/radius/scroll there
     instead, matching the mockup's own .table-scroll convention -- content
     authors don't have to remember to add the wrapper themselves. Skips
     tables an author already wrapped by hand. */
  function wrapTables(articleBody) {
    var tables = articleBody.querySelectorAll('table');
    tables.forEach(function (table) {
      if (table.parentElement.classList.contains('table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  function init() {
    var articleBody = document.getElementById('articleBody');
    var list = document.getElementById('tocList');
    var details = document.getElementById('tocDetails');
    var countEl = document.getElementById('tocCount');
    if (!articleBody) return;

    wrapTables(articleBody);
    removeRuffruffToc(articleBody);

    if (!list || !details) return;

    /* H2s only -- the TOC lists top-level sections (client request). H3
       sub-headings are intentionally excluded so the list stays a short,
       scannable set of numbered sections rather than a nested outline. */
    var heads = articleBody.querySelectorAll('h2');
    if (!heads.length) {
      var tocWrap = details.closest('.toc');
      if (tocWrap) tocWrap.style.display = 'none';
      return;
    }

    var links = [];
    var targets = [];
    var sectionCount = 0;
    var usedIds = {};

    heads.forEach(function (h, index) {
      if (!h.id) {
        var base = slugify(h.textContent) || 'section';
        var id = base;
        var n = 1;
        while (usedIds[id] || document.getElementById(id)) {
          n += 1;
          id = base + '-' + n;
        }
        h.id = id;
      }
      usedIds[h.id] = true;

      sectionCount += 1;

      var li = document.createElement('li');

      var a = document.createElement('a');
      a.href = '#' + h.id;

      /* Numbered node (01, 02, ...) + heading text. The number circle and the
         gradient connector line between circles are drawn in CSS; the markup
         just supplies the zero-padded index and the label. */
      var num = document.createElement('span');
      num.className = 'tnum';
      num.textContent = (index + 1 < 10 ? '0' : '') + (index + 1);
      num.setAttribute('aria-hidden', 'true');

      var text = document.createElement('span');
      text.className = 'ttext';
      text.textContent = h.textContent;

      a.appendChild(num);
      a.appendChild(text);
      a.addEventListener('click', function () {
        if (window.innerWidth < 760) details.open = false;
      });

      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
      targets.push(h);
    });

    if (countEl) {
      countEl.textContent = sectionCount + (sectionCount === 1 ? ' section' : ' sections');
    }

    if ('IntersectionObserver' in window) {
      var spy = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              links.forEach(function (a) {
                a.classList.toggle('active', a.getAttribute('href') === '#' + entry.target.id);
              });
            }
          });
        },
        { rootMargin: '-90px 0px -70% 0px', threshold: 0 }
      );
      targets.forEach(function (t) {
        spy.observe(t);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
